export const SET_IPD_INVOICE = 'SET_IPD_INVOICE';
export const UPDATE_IPD_INVOICE = 'UPDATE_IPD_INVOICE';
export const SET_SELECTED_SECTION = 'SET_SELECTED_SECTION';
export const VOID_IPD_INVOICE = 'VOID_IPD_INVOICE';
export const FETCH_ALL_IPD_INVOICES = 'FETCH_ALL_IPD_INVOICES';
